import React from 'react';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import TextForm from 'components/TextForm';
import authRequest from '../../service/authRequest';
import * as Styles from 'pages/function3/styles';
import config from '../../config';

const serviceId = config.mykeepin.serviceId;
const type = config.mykeepin.authType.function3;
const redirectUri = config.mykeepin.redirectUri.function3;

// Page function3 (페이지명은 추후에 바뀔 수 있음)
class function3 extends React.Component {
  state = {
    input: {
      metaId: '',
      sampleStringData: '',
    }
  }

  // Rendering
  render() {
    return (
      <Styles.PageLayout>
        <Styles.GridLayout>

          {/* 최상단 coinplug logo */}
          <Styles.LogoContainer>
            <Styles.Logo src={coinplug_logo} alt="coinplug-logo" />
          </Styles.LogoContainer>

          {/* 페이지 title */}
          <Styles.PageTitle>
            PUSH SAMPLE
          </Styles.PageTitle>

          {/* 샘플 텍스트 */}
          <Styles.Paragraph>
            Metadium DID 기반 인증 서비스를 테스트합니다. Meta ID를 입력하면 특정 유저에게 푸시 알림을 보낼 수 있습니다. 또한 인증 절차는 입력하신 Meta ID 만이 진행할 수 있습니다. Data 입력 시 Signature 를 위한 Nonce 값에 입력한 문자의 Hash 값이 추가됩니다.
          </Styles.Paragraph>

          <Styles.InputContainer>
            <TextForm
              style={{ margin: "74px 0 0 0" }}
              header="Meta ID"
              placeholder="Please input your Meta ID"
              name="metaId"
              value={this.state.metaId}
              onChange={this.handleChange}
            />
            <TextForm
              style={{ margin: "24px 0 0 0" }}
              header="Sample String Data"
              placeholder="Please Input sample data to sign with Keepin"
              name="sampleStringData"
              value={this.state.sampleStringData}
              onChange={this.handleChange}
            />
            <Styles.LoginButtonContainer>
              <Styles.LoginButton onClick={this.onClickLoginButton}> Login </Styles.LoginButton>
            </Styles.LoginButtonContainer>
          </Styles.InputContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    )
  }
  // Input change 이벤트 헨들러
  handleChange = (e) => {
    const { name, value } = e.target;
    const input = this.state.input;
    input[name] = value;
    this.setState({ input });
  }

  // On click login button
  onClickLoginButton = async () => {
    localStorage.setItem('metaId', this.state.input.metaId);
    localStorage.setItem('sampleStringData', this.state.input.sampleStringData);

    const did = this.state.input.metaId; // did:meta:000000000000000000000000000000000000000000000000000000000000604c
    const data = this.state.input.sampleStringData; // 0x1111111111111111111111111111111111111111111111111111111111111111

    // 인증 요청 URI 로 리다이렉트
    const authRequestUri = authRequest({ serviceId, redirectUri, type, did, data });
    window.location.assign(authRequestUri); 
  }
}

export default function3;